export default "__VITE_ASSET__Bs_APZ94__"